export enum MimeType {
    CSV = 'text/csv',
}
